module.exports = ".add-wallet {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 99; }\n\n.white-icon {\n  color: white; }\n"